import React, { useEffect, useState } from "react";
import { Carousel, CarouselItem, CarouselControl, Spinner } from "reactstrap";
import { adsRepo } from "data/repositories/adsRepo";

export default function AdBannerSlider({ placement = "home" }) {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      try {
        const items = await adsRepo.listByPlacement(placement);
        if (!cancelled) {
          setBanners(items);
          setActiveIndex(0);
        }
      } catch {
        if (!cancelled) setBanners([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [placement]);

  const next = () => {
    if (animating || !banners.length) return;
    setActiveIndex((i) => (i === banners.length - 1 ? 0 : i + 1));
  };

  const previous = () => {
    if (animating || !banners.length) return;
    setActiveIndex((i) => (i === 0 ? banners.length - 1 : i - 1));
  };

  if (loading) {
    return (
      <div className="mb-4 text-center py-4">
        <Spinner color="primary" size="sm" />
      </div>
    );
  }

  if (!banners.length) return null;

  return (
    <Carousel activeIndex={activeIndex} next={next} previous={previous} className="mb-4">
      {banners.map((b) => (
        <CarouselItem key={b.id} onExiting={() => setAnimating(true)} onExited={() => setAnimating(false)}>
          <a
            href={b.linkUrl || undefined}
            target={b.linkUrl ? "_blank" : undefined}
            rel={b.linkUrl ? "noreferrer" : undefined}
            style={{ textDecoration: "none" }}
          >
            <div
              className="rounded p-4 text-white position-relative overflow-hidden"
              style={{
                minHeight: 140,
                backgroundColor: b.backgroundColor || "#1B4332",
                backgroundImage: b.imageUrl ? `linear-gradient(rgba(0,0,0,.35), rgba(0,0,0,.45)), url(${b.imageUrl})` : undefined,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="small text-uppercase mb-2 opacity-8">Reklam</div>
              <h3 className="text-white mb-1">{b.title}</h3>
              <p className="mb-0 opacity-8">{b.subtitle}</p>
            </div>
          </a>
        </CarouselItem>
      ))}
      {banners.length > 1 ? (
        <>
          <CarouselControl direction="prev" directionText="Önceki" onClickHandler={previous} />
          <CarouselControl direction="next" directionText="Sonraki" onClickHandler={next} />
        </>
      ) : null}
    </Carousel>
  );
}
